import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { TabAttachmentsHOC } from '../../hocs/TabAttachmentsHOC';

export function TabAttachmentsContext() {
    const { boardId } = React.useContext(AsidePanelContext);
    return <TabAttachmentsHOC boardId={boardId} />
}
